<template>
    <th
        class="TableHeader"
        @click="onClick"
    >
        <a :class="labelClass">{{ label }}</a>
    </th>
</template>
<script>
export default {
    name: 'TableHeader',
    props: {
        label: {
            type: String,
            required: true
        },
        property: {
            type: String,
            required: true
        },
        sortable: {
            type: Boolean,
            required: true,
        },
        sortProperty: {
            type: Object,
            default: () => ({key: 'sort_by', direction: 'sort_direction'})
        },
        activeSort: {
            type: String,
            default: ''
        },
        activeSortDirection: {
            type: String,
            default: 'asc',
            validator: val => ['asc', 'desc'].indexOf(val) !== -1,
        }
    },
    computed: {
        isActiveSort() {
            return this.property === this.activeSort;
        },
        labelClass(){
            return {
                'TableHeader': true,
                'TableHeader__sort': this.sortable,
                'TableHeader__sort--active': this.isActiveSort,
                'TableHeader__sort--ascending': this.isActiveSort && this.activeSortDirection === 'asc',
                'TableHeader__sort--descending': this.isActiveSort && this.activeSortDirection === 'desc',
            };
        }
    },
    methods: {
        onClick(){
            const data = this.isActiveSort ? {
                [this.sortProperty.key]: this.property,
                [this.sortProperty.direction]: this.activeSortDirection === 'asc' ? 'desc' : 'asc'
            } : {
                [this.sortProperty.key]: this.property,
                [this.sortProperty.direction]: 'desc'
            };
            this.$emit('set-sort', data );
        },
    },
};
</script>
<style lang="scss">
    .TableHeader {
        color: $text-dark;
        font-weight: 400;
        cursor: pointer;
        text-decoration: none;
        padding-right: 1rem;
        position: relative;
        white-space: nowrap;

        &__sort{
            cursor: pointer;
            text-decoration: none;
            padding-right: 1rem;
            position: relative;
            &:before,
            &:after {
                border: 4px solid transparent;
                content: "";
                display: block;
                height: 0;
                right: 5px;
                top: 50%;
                position: absolute;
                width: 0;
            }
            &:before {
                border-bottom-color: $text-dark;;
                margin-top: -9px;
            }
            &:after {
                border-top-color: $text-dark;;
                margin-top: 1px;
            }
            &--active {
                &:before,
                &:after {
                    border: 4px solid transparent;
                    content: "";
                    display: block;
                    height: 0;
                    top: 50%;
                    position: absolute;
                    width: 0;
                }
            }
            &--descending {
                &:before {
                    border-bottom-color: $grey;
                    margin-top: -9px;
                }
                &:after {
                    border-top-color: $primary;
                    margin-top: 1px;
                }
            }
            &--ascending {
                &:before {
                    border-bottom-color: $primary;
                    margin-top: -9px;
                }
                &:after {
                    border-top-color: $grey;
                    margin-top: 1px;
                }
            }
        }
    }
</style>
